export default __webpack_public_path__ + "static/media/jane-churchyard-screengrab-5.05a0405c.jpg";